export default "__VITE_ASSET__2Zq4vnb0__"